export default "__VITE_ASSET__gv5oNjwK__"